import { useTranslation } from 'react-i18next';

import { completeTask } from '@/api/interviews';
import InterviewStageModalForm from '@/components/form/InterviewStageModalForm';
import { PageTitle } from '@/UI/typography';

import type { InterviewRoom } from '@/types/interview';

interface InterviewStageProps {
  interview: InterviewRoom;
  onComplete: (id: string) => void;
}

const InterviewStage = ({ interview }: InterviewStageProps) => {
  const { t } = useTranslation();
  const handleComplete = (id: string) => {
    void completeTask(interview.id, id);
  };
  return (
    <div>
      <PageTitle>{t(interview.current_stage?.stage_name ?? '')}</PageTitle>
      <InterviewStageModalForm
        interview={interview}
        handleComplete={handleComplete}
      />
    </div>
  );
};

export default InterviewStage;
